import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPage/getError'
import useCadastralFields from './useCadastralFields'

const CadastralFields = () => {
  const {
    t,
    errors,
    isEditable,
    cadastralSheetNumber,
    cadastralParcelNumber,
    cadastralSubunitNumber,
    hidden,
    updateAddress,
  } = useCadastralFields()

  if (hidden) return null

  return (
    <>
      <SDFormControl error={getError('cadastral_sheet_number', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.cadastral_fields.sheet_number')}
          disabled={isEditable === false}
          currentValue={cadastralSheetNumber ?? ''}
          onBlur={(value: string | null) => updateAddress({ cadastral_sheet_number: value ?? '' })}
          error={getError('cadastral_sheet_number', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl error={getError('cadastral_parcel_number', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.cadastral_fields.parcel_number')}
          disabled={isEditable === false}
          currentValue={cadastralParcelNumber ?? ''}
          onBlur={(value: string | null) => updateAddress({ cadastral_parcel_number: value ?? '' })}
          error={getError('cadastral_parcel_number', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl error={getError('cadastral_subunit_number', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.cadastral_fields.subunit_number')}
          disabled={isEditable === false}
          currentValue={cadastralSubunitNumber ?? ''}
          onBlur={(value: string | null) => updateAddress({ cadastral_subunit_number: value ?? '' })}
          error={getError('cadastral_subunit_number', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>
    </>
  )
}

export default CadastralFields
